const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_tfun-sites-preview/artifacts/8e6fw7zf_TFUN_Site_Factory_800px_under_500kb.png";

export default function BrandMark({ compact = false }) {
  return (
    <span className={`brand-mark ${compact ? "brand-mark-compact" : ""}`}>
      <img src={LOGO_URL} alt="TFUN Sites logo" />
      <span className="brand-copy"><strong>TFUN <b>SITES</b></strong>{!compact && <small>A DIVISION OF THE FOLLOW UP NINJA</small>}</span>
    </span>
  );
}
